import { Box } from '@mui/material'
import { memo, useContext } from 'react'
import { Context } from './Context';
import { gettingTotalWorkedHours } from '../../../utils/Timecard';
import moment from 'moment';

const WorkedHoursCell = memo(({params}) => {
    const regex = /auto-generated-row-null/;

    const {
        apiRef,
        periods,
        range1,
    } = useContext(Context);

    const gettingOpacity = () => {
        const period = periods.find(period => period.full_name === params?.rowNode?.groupingKey)

        if(period){
            if(moment(period.end_date, 'YYYY-MM-DD').isSameOrAfter(moment(range1[1], 'YYYY-MM-DD'))){
                return 0.5
            }else{
                return 1
            }
        }else{
            return 1
        }
    }

    return (
        <>
            <Box 
                sx={{
                    width: '100%',
                    display:'grid', 
                    placeItems: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                    gap: '10px',
                    p: 1.5,
                }}
            >
                { regex.test(params?.id) ?
                    <Box 
                        sx={{
                            opacity: gettingOpacity(),
                        }}
                        //onClick={() => console.log('params', params)}
                    >
                        { gettingTotalWorkedHours(params, apiRef) }
                    </Box>
                    :
                    <Box
                        sx={{
                            opacity: params?.row?.open_period?.open === false ? 0.5 : 1,
                        }}
                    >
                        { params?.value }
                    </Box>
                }
            </Box>
        </>
    )
})

export {
    WorkedHoursCell
} 